// Default behavior is to use the primary auth mode for an API,
// so we are returning an empty array so that DataStore will default
// to using the primary auth mode.
export var defaultAuthStrategy = function () { return []; };
//# sourceMappingURL=defaultAuthStrategy.js.map